export default __webpack_public_path__ + "static/media/sticker-U.c3ec600c.png";